// @flow
import { useMemo } from 'react';

import SimpleDate from 'app/dataProviders/SimpleDate';

import type { Period } from './usePeriods';


const maxMonthsPerPeriod = 12;
const emptyMonths = [];

type Month = {
  title: string,
  link: string,
  current: boolean,
}

export default function useMonths(
  period: Period | null,
  date: SimpleDate,
  createPath: ({ date?: SimpleDate, summary: boolean }) => string
): Array<Month> {
  const res = useMemo(() => {
    if (!period) {
      return emptyMonths;
    }
    const { start, finish } = period;
    let current = new SimpleDate(...start.getValueAndFormat());
    const months = [];
    let index = 0;
    do {
      months.push({
        title: current.getString('MMMM'),
        link: createPath({ date: current, summary: false }),
        current: current.isSame(date, SimpleDate.units.month),
      });
      current = new SimpleDate(...current.nextMonth());
      index += 1;
    } while (current.isSameOrBefore(finish, SimpleDate.units.month) && index < maxMonthsPerPeriod);

    return months;
  }, [period, date, createPath]);

  return res;
}
